import { render, staticRenderFns } from "./titleItem.vue?vue&type=template&id=5d722d52&scoped=true"
import script from "./titleItem.vue?vue&type=script&lang=js"
export * from "./titleItem.vue?vue&type=script&lang=js"
import style0 from "./titleItem.vue?vue&type=style&index=0&id=5d722d52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d722d52",
  null
  
)

export default component.exports